import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { useNavigate } from "react-router-dom"; // 👈 import from react-router-dom

const Navbar = ({ isShrunk, navLinks = [], isFixed = true, bgColor = "bg-white" }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate(); // 👈 initialize navigation hook

    // handle link click
    const handleNavClick = (path) => {
        setMenuOpen(false); // close mobile menu
        navigate(path); // navigate programmatically
    };

    return (
        <nav
            className={`w-full z-50 transition-all duration-500 ${isFixed ? "fixed top-0" : ""
                } ${isShrunk ? `${bgColor} shadow-md py-2` : `${bgColor} bg-white shadow-md py-3`
                }`}
        >
            <div
                className={`px-6 md:px-8 flex items-center justify-between transition-all duration-500 ${isShrunk
                    ? "flex-row gap-2"
                    : "flex-row md:flex-col gap-3 md:gap-3"
                    }`}
            >
                {/* Logo */}
                <h1
                    onClick={() => handleNavClick("/")}
                    className={`font-bold cursor-pointer transition-all duration-300 ${isShrunk ? "text-lg" : "text-xl"
                        }`}
                >
                    <span className={isShrunk ? "font-semibold" : "font-bold"}>
                        Because
                    </span>{" "}
                    <span className="font-black">Science</span>
                </h1>

                {/* Desktop nav links */}
                <div className="hidden md:flex gap-5 space-x-6 text-sm md:text-sm">
                    {navLinks.map(({ label, href }) => (
                        <button
                            key={href}
                            onClick={() => handleNavClick(href)} // 👈 use navigate
                            className="text-sm font-medium hover:text-blue-600 transition"
                        >
                            {label}
                        </button>
                    ))}
                </div>

                {/* Hamburger for mobile */}
                <button
                    onClick={() => setMenuOpen(!menuOpen)}
                    className="md:hidden focus:outline-none"
                >
                    {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                </button>
            </div>

            {/* Mobile menu */}
            {menuOpen && (
                <div className="md:hidden px-6 pb-4 space-y-2 text-sm bg-white shadow-sm">
                    {navLinks.map(({ label, href }) => (
                        <button
                            key={href}
                            onClick={() => handleNavClick(href)} // 👈 use navigate
                            className="block w-full text-left text-gray-700 font-medium hover:text-blue-600 transition"
                        >
                            {label}
                        </button>
                    ))}
                </div>
            )}
        </nav>
    );
};

export default Navbar;
